import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import {notification, Typography} from "antd";
import {uuidv4} from "../../../../../utils";
import {getDeviseSymbol} from "../../../../../i18n";
import {DEBUG} from "../../../../../config";

const {Text,Title}=Typography


export default function ScreenDonSection({context,campagneData,})
{
    const [loading,setLoading]=useState(true)
    const [dons,setDons]=useState([])

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:2 })

    const partnerMontant=campagneData?.partnerMontant || 1

    let donorName=campagneData.config?.donorName || "Parrainages"

    const screenOptions=campagneData?.screenOptions || {}


    const getDisplayName=(campagneExtraData={})=>{
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons=async ()=>{
        let url="/campagne/donors/"+campagneData.id+"?all=1"

        const res=await ApiService.get(url)
        let _dons=res.data

        if(!DEBUG){
            _dons=_dons.filter(i=>i.montant===360)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    if(loading){
        return null
    }

    return (
        <div style={{width:"100%",height:"7vh",display:"flex",flexDirection:"column"}}>
            <MarqueeInline direction="left" speed={dons.length*15}>
                {dons.map((d,index)=>{

                    //console.log(index)


                    //console.log(className)

                    return(
                        <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",backgroundColor:"#FFFFFF55",border:"5px solid #FFFFFF55",width:"17vw",height:"6vh"}} key={d.id}>
                            <span style={{color:"#FFF",fontSize:"1.8vh",fontWeight:"600",textAlign:"center",padding:"5px",width:"100%",whiteSpace:"wrap",overflow:"hidden"}}>{getDisplayName(d.campagneExtraData)}</span>
                        </div>
                    )
                })}
            </MarqueeInline>
        </div>
    )
}


function MarqueeInline({
                                          children,
                                          speed = 20,      // durée de l’animation en secondes
                                          gap = 40,        // espace entre les répétitions
                                          direction = "left" // "left" ou "right"
                                      }) {

    // Inject keyframes si pas déjà présent
    useEffect(() => {
        const id = "marquee-inline-keyframes";

        if (!document.getElementById(id)) {
            const style = document.createElement("style");
            style.id = id;
            style.innerHTML = `
        @keyframes marquee-inline-left {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        @keyframes marquee-inline-right {
          from { transform: translateX(-50%); }
          to   { transform: translateX(0); }
        }
      `;
            document.head.appendChild(style);
        }
    }, []);

    const animationName =
        direction === "right"
            ? "marquee-inline-right"
            : "marquee-inline-left";

    return (
        <div
            style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "100%"
            }}
        >
            <div
                style={{
                    display: "inline-flex",
                    animation: `${animationName} ${speed}s linear infinite`,
                    gap: gap,
                }}
            >
                <div style={{ display: "inline-flex", gap }}>{children}</div>
                <div style={{ display: "inline-flex", gap }}>{children}</div>
            </div>
        </div>
    );
}